import React from 'react';
import DiagnosticsPage from '@/components/Diagnostics/DiagnosticsPage';

export default function DiagnosticsRoute() {
    return <DiagnosticsPage />;
}
